import React from "react"
import cn from "classnames"
import Icon from "../general/Icon"
import { t } from "../../i18n"

interface BackLinkProps {
  className?: string
  href: string
}

const BackLink: React.FC<BackLinkProps> = (props: BackLinkProps) => {
  const className = cn("Button Button--light Button--wIcon", props.className)
  return (
    <a className={className} href={props.href}>
      <Icon size="24" symbolId="arrow-left"/>
      {t("controls.buttons.back")}
    </a>
  )
}

export default BackLink
